import React from 'react';
import { useParams } from 'react-router-dom';

const VideoDetails = () => {
  const { id } = useParams();
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Video Details</h1>
      <p>Details for video {id} coming soon...</p>
    </div>
  );
};

export default VideoDetails;